import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

// Initialize Stripe with the publishable key. No hardcoded fallback: a
// missing env var should fail loudly rather than silently loading Stripe
// against whichever test account this key happened to belong to.
//
// loadStripe() must receive either a real key or exactly `null` - it throws
// on `undefined`/`''` instead of failing gracefully, and CRA resolves an
// unset REACT_APP_* var to `''` in the built bundle, not `undefined`.
const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || null;
if (!stripeKey) {
  console.error('REACT_APP_STRIPE_PUBLISHABLE_KEY is not set - Stripe will not load');
}

// Suppress console warnings in development for Stripe HTTPS messages
if (process.env.NODE_ENV === 'development') {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    // Filter out Stripe HTTPS warnings in development
    if (args[0] && typeof args[0] === 'string' && 
        args[0].includes('You may test your Stripe.js integration over HTTP')) {
      return; // Suppress this specific warning
    }
    originalWarn.apply(console, args);
  };
}

// Create the Stripe promise - Elements can handle promises directly
const stripePromise = loadStripe(stripeKey);

const StripeProvider = ({ children }) => {
  // Elements component can accept a promise directly, so we don't need to wait
  // It will handle the promise resolution internally
  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default StripeProvider;